import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "defined"
    }}>{`:defined`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v6.0`}</p>
    <p>{`Represents any element that has been defined.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/:defined"
      }}>{`:defined`}</a></p>
    <p><strong parentName="p">{`Syntax:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`:defined {
  /* ... */
}
`}</code></pre>
    <p><strong parentName="p">{`Example:`}</strong></p>
    <br></br>
Demonstrates the application of styles via `:defined`
    <CodeBlock slots="heading, code" repeat="2" languages="HTML, CSS" mdxType="CodeBlock" />
    <h4 {...{
      "id": "html"
    }}>{`HTML`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<simple-custom text="Custom element example text"></simple-custom>

<p>Standard paragraph example text</p>
`}</code></pre>
    <h4 {...{
      "id": "css"
    }}>{`CSS`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`/* Give the \`p\` elements distinctive background */
p {
  background: yellow;
}

/* Both the custom and the built-in element are given italic text */
:defined {
  font-style: italic;
}

/* Only simple-custom element is applied with green background*/
simple-custom:defined {
  display: block;
  background: green;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      